module.exports = __webpack_public_path__ + "718d88ac796555561e1e56189106bc21.svg";